// extracted by mini-css-extract-plugin
module.exports = {"detailsRow":"styles_detailsRow__RhxqE"};